import React, { useState } from 'react';

import {
    Button, Group, Space, Stack, Text, Title, Skeleton, Select,
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useLocalStorage } from '@mantine/hooks';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

import Fetcher from '../common/communicate';
import { ENT_TYPES } from '../const';

dayjs.locale('ru');

const DATE_SERVER_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const DATE_CLIENT_FORMAT = 'D MMMM';

const STORY_TYPES = ENT_TYPES.map((type) => ({
    value: type.id,
    label: type.name,
}));

export default function ReportScreen() {
    const [date, setDate] = useState([null, null]);
    const [storyType, setStoryType] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [reports, setReports] = useLocalStorage({ key: 'content-reports', defaultValue: [] });

    function createReport() {
        if (!date) {
            return;
        }

        setLoading(true);

        const from = dayjs(date[0]).format(DATE_SERVER_FORMAT);
        const to = dayjs(date[1]).add(23, 'h').add(59, 'm').add(59, 's')
            .format(DATE_SERVER_FORMAT);

        Fetcher('v4/story/report/', 'POST', (data) => {
            setReports([
                ...reports,
                {
                    from,
                    to,
                    type: STORY_TYPES.find((type) => type.value === storyType)?.label,
                    ...data,
                },
            ]);

            setLoading(false);
            setDate([null, null]);
        }, {
            date_from: from,
            date_to: to,
            type: storyType,
            project: 'media.vkplay.ru',
        });
    }

    function removeReport(e) {
        const { index } = e.currentTarget.dataset;

        setReports(reports.filter((_, i) => i !== +index));
    }

    return (
        <div>
            <Space h="sm" />
            <Title order={1}>Отчёты</Title>
            <Space h="lg" />
            <Group align="flex-end">
                <DatePickerInput
                    type="range"
                    locale="ru"
                    label="Временной промежуток"
                    placeholder="Выбрать"
                    value={date}
                    onChange={setDate}
                    maw={310}
                />
                <Select
                    label="Тип материала"
                    placeholder="Выбрать"
                    data={STORY_TYPES}
                    value={storyType}
                    onChange={setStoryType}
                />
                <Button
                    onClick={createReport}
                >
                    Создать отчёт
                </Button>
            </Group>
            <Space h="xl" />
            <Space h="xl" />
            <Stack>
                {reports.map(({
                    from, to, url, type,
                }, i) => (
                    <Group key={`${from}-${to}`}>
                        <Text style={{ width: 458 }}>
                            {dayjs(from).format(DATE_CLIENT_FORMAT)}
                            {' '}
                            —
                            {dayjs(to).format(DATE_CLIENT_FORMAT)}
                            {' '}
                            (
                            {type || 'Все материалы'}
                            )
                        </Text>
                        <Button
                            variant="outline"
                            component="a"
                            href={url}
                            target="__blank"
                        >
                            Скачать
                        </Button>
                        <Button
                            variant="light"
                            color="red"
                            data-index={i}
                            onClick={removeReport}
                        >
                            Удалить
                        </Button>
                    </Group>
                ))}
                {isLoading && <Skeleton height={36} width={466} />}
            </Stack>
        </div>
    );
}
